<footer>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <div class="logo pointer" routerLink="/" routerLinkActive="router-link-active">
          <img class="w-100" src="assets/images/logo-white.png" [title]="'MENU.TOOLBAR.TITLE' | translate" [alt]="'MENU.TOOLBAR.ALT' | translate" />
        </div>
      </div>
      <div class="col-md-6 mt-md-0 mt-4">
        <div class="row">
            <div class="col-md-4">
              <div class="pointer mb-3" (click)="scrollTo('home')">{{'MENU.TOOLBAR.HOME' | translate}}</div>
              <div class="pointer mb-3" (click)="scrollTo('soluciones')">{{'MENU.TOOLBAR.SOLUTION' | translate}}</div>
            </div>
            <div class="col-md-4">
              <div class="pointer mb-3" (click)="scrollTo('objetivo')">{{'MENU.TOOLBAR.OBJETIVE' | translate}}</div>
              <div class="pointer mb-3" (click)="scrollTo('proyectos')">{{'MENU.TOOLBAR.PROJECTS' | translate}}</div>
            </div>
            <div class="col-md-4">
              <div class="pointer" (click)="scrollTo('contacto')">{{'MENU.TOOLBAR.CONTACT' | translate}}</div>
            </div>
        </div>
      </div>
      <!--div class="col-md-3 mt-md-0  mt-4">
        <h4>Redes</h4>
        <div class="d-flex mt-4">
            <div class="icons pointer"><img src="assets/images/ic-instagram-white.svg" alt=""></div>
            <div class="icons pointer ms-3"><img src="assets/images/ic-linkedin-white.svg" alt=""></div>
        </div>
    </div--> 
    </div>
  </div>
  <hr>
  <div class="container">
    <p class="mb-0">{{'MENU.TOOLBAR.COPYRIGHT' | translate}}2023 - Creado por <a href="http://www.tuerc.ar" target="_blank">tuerc.ar</a></p>
  </div>
</footer>
